import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../helpers';

import { ComponentStyle } from '../../types/types';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const P = styled.p({
  [mqBreakpoints.tablet]: {
    width: pxToRem(480),
  },
  [mqBreakpoints.desktop]: {
    width: 'auto',
  },
});

type Props = {
  title: string;
  strapline?: string;
  style?: ComponentStyle;
};

export const CtaHeader: React.FC<Props> = ({ title, strapline, style }) => {
  const stylesWithH2: ComponentStyle[] = [ComponentStyle.E, ComponentStyle.F];
  return (
    <>
      {stylesWithH2.includes(style) ? <h2 data-testid='mp-product-cta-title'>{title}</h2> : <h1 data-testid='mp-product-cta-title'>{title}</h1>}
      {strapline ? (
        <P className='strapline' data-testid='mp-product-cta-description'>
          {parseHtml(strapline)}
        </P>
      ) : null}
    </>
  );
};
